import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { pillars, audience } from '../data/content';
export function MethodSection() {
  return <section aria-labelledby="metodo" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-176" data-mp="2u8rdayx3v19">
      <Reveal className="text-center" data-id="element-177" data-mp="3uyj9tivmc1os">
        <p className="font-display text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-178" data-mp="3uzlzxol4a03n">
          El sistema de CM Digital Pro™
        </p>
        <h2 id="metodo" className="mt-1.5 font-display text-2xl md:text-3xl font-extrabold uppercase leading-tight text-ink" data-id="element-179" data-mp="qk30bhg48zg8">
          Mega Pack Electrónica para Emprender
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-base text-ink-muted" data-id="element-180" data-mp="hs145vd2y5br">
          Diseñado para quienes quieren dejar de acumular tutoriales y empezar a{' '}
          <span className="font-semibold text-ink" data-id="element-181" data-mp="1ebi7pomr26yc">
            aprender, practicar y hacer
          </span>
          .
        </p>
      </Reveal>

      <div className="mt-6 grid gap-4 lg:grid-cols-[1.25fr_0.75fr]" data-id="element-182" data-mp="1v1z48ozpynfm">
        <ol className="grid gap-3 sm:grid-cols-3" data-id="element-183" data-mp="201byvvwu0ysr">
          {pillars.map((pillar, i) => <Reveal key={pillar.title} as="li" delay={i * 0.04} className="flex h-full flex-col rounded-xl border border-line bg-surface p-5" data-id="element-184" data-mp="1lcfjtewcylin" data-mpi={i}>
              <span className="font-display text-xs font-bold uppercase tracking-[0.14em] text-accent" data-id="element-185" data-mp="1cc0u83cd2k9c">
                Pilar {i + 1}
              </span>
              <h3 className="mt-1.5 font-display text-lg font-extrabold uppercase text-ink" data-id="element-186" data-mp="1hc5f05kay15d">
                {pillar.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-187" data-mp="17cehrw4cx81l">
                {pillar.desc}
              </p>
            </Reveal>)}
        </ol>

        <Reveal delay={0.08} className="rounded-xl border border-volt/30 bg-volt-soft p-5" data-id="element-188" data-mp="2wphzm7qmv71r">
          <h3 className="font-display text-sm font-bold uppercase tracking-wide text-volt" data-id="element-189" data-mp="309ihl2rknjyf">
            Pensado especialmente para
          </h3>
          <ul className="mt-3 space-y-2" data-id="element-190" data-mp="2v9nqay3vwscu">
            {audience.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink" data-id="element-191" data-mp="2qakm1fvqaq5x">
                <CheckIcon size={14} className="mt-1 flex-shrink-0 text-volt" strokeWidth={3} data-id="element-192" data-mp="2mbbtgecfcyby" />
                <span data-id="element-193" data-mp="3e0n9tjsm19yq">{item}</span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}